
import { Component, PropSync, Vue } from 'vue-property-decorator'
import VueHtml2pdf from 'vue-html2pdf'
import Project from "@/types/project/project"
import { State } from "vuex-class"
import User from "@/types/account/user"
import { DateAndTimeHelper } from "@/helpers/DateAndTimeHelper"
import ExportExpenditure from "@/types/expenditure/exportExpenditure"
import { ProjectService } from "@/services/timetrack/ProjectService"
import { AccountService } from "@/services/account/AccountService"

@Component({
  filters: {
  },
  components: {
    VueHtml2pdf
  }
})
export default class Pdf extends Vue {
  private users: User[] | null = null
  private accountService = new AccountService()
  private projectService = new ProjectService()
  private dateTimeHelper = new DateAndTimeHelper()

  @PropSync('selectedProjects') projects!: Project[];

  @State((state: any) => state.user, { namespace: 'account' })
  private user!: User;

  mounted () {
    const projectIds = this.projects
      .map((project) => { return project.id })
    this.projectService.getUserIdsFromProjects(projectIds)
      .then((userIds) => {
        this.accountService.getUsersByIds(userIds)
          .then((users) => {
            users = users.sort((a, b) => {
              return this.projects.findIndex((p) => p.userId === a.id) - this.projects.findIndex((p) => p.userId === b.id)
            })
            this.users = users
            setTimeout(() => {
              this.$emit('projectsToDownload', Object.keys(this.$refs))
              Object.keys(this.$refs).forEach(el => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.$refs[el][0].generatePdf()
              })
            }, 1000)
          })
      })
  }

  private get companyLogoUrl () {
    return process.env.VUE_APP_STORAGE_BASE_URL + this.user.companyLogo
  }

  private async beforeDownload (event: any) {
    await event.html2pdf().set(event.options).from(event.pdfContent).toPdf().get('pdf').then((pdf: any) => {
      const totalPages = pdf.internal.getNumberOfPages()
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i)
        pdf.text(this.$t('timetrack.export.pdf.page') + ' ' + i + ' ' + this.$t('timetrack.export.pdf.from') + ' ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.82), (pdf.internal.pageSize.getHeight() - 0.2))
      }
    }).save()
  }

  private formatCurrency (value: number) {
    return Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(value)
  }

  private getExpenditures (projectIndex: number) {
    const expenditureEntries: ExportExpenditure[] = []
    if (!this.projects || !this.projects[projectIndex]) return
    if (this.projects[projectIndex].trackedTimes) {
      this.projects[projectIndex].trackedTimes!.forEach((tracking) => {
        if (!tracking || !tracking.expenditures) return
        tracking.expenditures.forEach((expenditure) => {
          if (!tracking.startingTime || !expenditure.positionPrice || !expenditure.totalPrice) return
          expenditureEntries.push(
            new ExportExpenditure({
              id: expenditure.id,
              date: this.dateTimeHelper.getReadableDateFromStartingTime(tracking.startingTime),
              quantity: Number(expenditure.quantity),
              position: expenditure.position,
              positionPrice: Number(expenditure.positionPrice),
              totalPrice: Number(expenditure.totalPrice)
            })
          )
        })
      })
    }
    return expenditureEntries
  }

  private getTotalTrackingValue (projectIndex: number) {
    let timesSalaryValue = 0
    if (!this.projects || !this.projects[projectIndex]) return 0
    if (this.projects[projectIndex].trackedTimes) {
      this.projects[projectIndex].trackedTimes!.forEach((time) => {
        timesSalaryValue += Number(time.making)
      })
    }
    return timesSalaryValue
  }

  getTotalTrackingTime (projectIndex: number) {
    let timesValue = 0
    if (!this.projects || !this.projects[projectIndex]) return 0
    if (this.projects[projectIndex].trackedTimes) {
      this.projects[projectIndex].trackedTimes!.forEach((time) => {
        if (!time.startingTime) return
        timesValue += this.dateTimeHelper.timeStringToNumber(this.dateTimeHelper.getTrackedTimeWithoutSeconds(time.startingTime, Number(time.endTime)))
      })
    }
    return timesValue
  }

  private getTotalExpenditureValue (projectIndex: number) {
    let expSalaryValue = 0
    if (!this.projects || !this.projects[projectIndex]) return 0
    if (this.projects[projectIndex].trackedTimes) {
      this.projects[projectIndex].trackedTimes!.forEach((time) => {
        if (time.expenditures) {
          time.expenditures.forEach((exp) => {
            expSalaryValue += Number(exp.totalPrice)
          })
        }
      })
    }
    return expSalaryValue
  }
}

